import React, { useEffect } from 'react';
import { StickyUrgencyBar } from './components/StickyUrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainAgitation } from './components/PainAgitation';
import { MechanismReveal } from './components/MechanismReveal';
import { ProductPresentation } from './components/ProductPresentation';
import { Testimonials } from './components/Testimonials';
import { ForWhom } from './components/ForWhom';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MobileStickyBar } from './components/MobileStickyBar';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-gold selection:text-brand-dark" data-id="element-0">
      <StickyUrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainAgitation data-id="element-4" />
        <MechanismReveal data-id="element-5" />
        <ProductPresentation data-id="element-6" />

        {/* Separator Quote */}
        <div className="bg-brand-dark text-brand-gold py-12 px-4 text-center" data-id="element-7">
          <p className="text-xl sm:text-2xl font-serif italic max-w-4xl mx-auto" data-id="element-8">
            "El problema nunca fue lo que comías. Fue el orden en que lo
            hacías."
          </p>
        </div>

        <Testimonials data-id="element-9" />
        <ForWhom data-id="element-10" />
        <FAQ data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <MobileStickyBar data-id="element-15" />
    </div>;
}